import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AsReportedSecurity } from "src/api/models";

@Component({
  selector: "app-view-security-data",
  // imports: [],
  templateUrl: "./view-security-data.component.html",
  styleUrl: "./view-security-data.component.css",
  standalone: false,
})
export class ViewSecurityDataComponent {
  formData: any = {
    issuerId: "",
    issuerName: "",
    securityId: "",
    securityType: "",
    analyst: "",
  };
  securityData: AsReportedSecurity[] = [];
  noRecord: boolean = false;
  selectedSecurities: AsReportedSecurity[] = [];
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.securityData = this.config.data?.securityData || [];
    this.noRecord = this.config.data?.noRecord || false;
  }

  onCancel() {
    this.ref.close();
  }
  onRevertSecurity(security: any) {
    this.ref.close({ revertSecurity: security });
  }
  onGroupRevert() {
    if (this.selectedSecurities.length < 2) {
      return;
    }
    this.ref.close({ revertSecurities: this.selectedSecurities });
  }
}
